import React from 'react';
import styled from 'styled-components';

import { FacetFilterInput, FacetMetadata } from '../../types.generated';
import { SearchFilterLabel } from './SearchFilterLabel';

type Props = {
    facet: FacetMetadata;
    filter: FacetFilterInput;
    isCompact?: boolean;
    onClick?: () => void;
};

const ValueFilterSection = styled.div<{ isCompact?: boolean }>`
    :hover {
        cursor: pointer;
    }
    margin: 4px;
    ${(props) => props.isCompact && 'display: inline-flex;'}
`;

const StyledSearchFilterLabel = styled.div<{ isCompact?: boolean }>`
    margin: 4px;
    width: max-content;
    ${(props) => props.isCompact && 'display: inline-flex;'}
`;

export const AdvancedSearchFilterValuesSection = ({ facet, filter, isCompact, onClick }: Props) => {
    return (
        <ValueFilterSection isCompact={isCompact}>
            {filter?.values?.map((value) => {
                const matchedAggregation = facet?.aggregations?.find((aggregation) => aggregation.value === value);
                return (
                    <StyledSearchFilterLabel key={value} isCompact={isCompact} onClick={onClick}>
                        <SearchFilterLabel
                            hideCount
                            field={filter.field}
                            value={value}
                            entity={matchedAggregation?.entity}
                        />
                    </StyledSearchFilterLabel>
                );
            })}
        </ValueFilterSection>
    );
};
